var map = {
	"./affirm.svg": 196481,
	"./alipaycn.svg": 320789,
	"./alipayhk.svg": 580733,
	"./appcard.svg": 942967,
	"./applepay.svg": 825226,
	"./bancontact.svg": 991621,
	"./googlepay.svg": 114309,
	"./ibe.svg": 142118,
	"./ideal.svg": 508063,
	"./kakaopay.svg": 270555,
	"./klarna.svg": 907467,
	"./naverpay.svg": 822256,
	"./onlinebankingpl.svg": 727689,
	"./paypal.svg": 471141,
	"./paypay.svg": 168584,
	"./pix.svg": 552051,
	"./sofort.svg": 639741,
	"./trustly.svg": 397643,
	"./twint.svg": 647694,
	"./upi.svg": 963596,
	"./volt.svg": 527421
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 39280).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 764207;
module.exports = webpackAsyncContext;